import React from 'react';
import classNames from 'classnames';

import { InputNumber } from 'antd';

import './size-editor.less';

export default class Editor extends React.Component {
    render() {
        const {
            value,
            className,
            readOnly,
            disabled
        } = this.props;

        return (
            <span className={ classNames( 'size-editor', className ) }>
                <InputNumber
                    large={ true }
                    value={ value }
                    onChange={ this.handleInputChange }
                    min={ 0 }
                    readOnly={ readOnly }
                    disabled={ disabled }
                />
            </span>
        );
    }

    handleInputChange = ( value ) => {
        const { onChange } = this.props;

        if ( typeof onChange === 'function' ) {
            onChange( value.toString() );
        }
    };
}
